import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'formly-field-tabs',
  template: `
    <mat-tab-group>
      <mat-tab *ngFor="let tab of field.fieldGroup; let i = index; let last = last" 
               [label]="tab.props?.label || ''" 
               [disabled]="i !== 0 && field.fieldGroup && !isValid(field.fieldGroup[i - 1])"> <!-- Ensure field.fieldGroup exists -->
        <formly-field [field]="tab"></formly-field>
        <button *ngIf="last" class="btn btn-primary" [disabled]="!form.valid" type="submit">Submit</button>
      </mat-tab>
    </mat-tab-group>
  `,
  standalone:true,
  imports:[
    TranslateModule,MatTabsModule,MatFormFieldModule,CommonModule,FormlyModule,MatTooltipModule,MatIconModule
  ]
})
export class FormlyFieldTabs extends FieldType {
  isValid(field: FormlyFieldConfig): boolean {
    if (field.key && field.formControl) {
      return field.formControl.valid;
    }
    return field.fieldGroup ? field.fieldGroup.every((f) => this.isValid(f)) : true;
  }
}
